import React from 'react';
import ActionItem from './actionItem';

export default function ReportTableActions({ actions }) {
	return (
		<div
			className="d-flex justify-content-center align-items-center gap-4 p-3"
			style={{ borderBottom: '1px solid #EDEDF7' }}
		>
			{actions.map((action, index) => (
				<React.Fragment key={action.key}>
					<ActionItem action={action} />
					{index !== actions.length - 1 && (
						<div
							style={{
								width: '2px',
								background: '#EDEDF7',
								height: '20px',
							}}
						/>
					)}
				</React.Fragment>
			))}
		</div>
	);
}
